import { memo } from "react";
import Skeleton from "src/components/Skeleton";
import { LightText } from "src/components/v1";
import { cn } from "src/utilities/shadcnUtils";

export interface LegendIconProps {
  label: string;
  color: string;
  className?: string;
  loading?: boolean;
}

export interface LegendProps {
  className?: string;
  values: LegendIconProps[];
  loading?: boolean;
}

const CONTAINER_CLASS =
  "flex flex-row items-center flex-wrap max-w-[200px] [&:not(:last-child)]:mr-[45px] max-[600px]:[&:not(:last-child)]:mb-[15px]";
const ICON_CLASS = "h-6 w-6 rounded-full";
const LABEL_CLASS = "ml-[14px] text-base";

const LegendIcon = ({ label, color, className, loading }: LegendIconProps) =>
  loading ? (
    <div className={cn(CONTAINER_CLASS, className)}>
      <Skeleton circle width="24px" height="24px" className={ICON_CLASS} />
      <Skeleton width="100px" height="20px" className={LABEL_CLASS} />
    </div>
  ) : (
    <div className={cn(CONTAINER_CLASS, className)}>
      <div className={ICON_CLASS} style={{ backgroundColor: color }} />
      <LightText className={LABEL_CLASS}>{label}</LightText>
    </div>
  );

const Legend = ({ className, values, loading }: LegendProps) => (
  <div className={cn("flex flex-row items-center flex-wrap", className)}>
    {values.map((props) => (
      <LegendIcon key={props.label} loading={loading} {...props} />
    ))}
  </div>
);

export default memo(Legend);
